import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/VisionStrategy/components/SectionGoal/SectionGoal.module.scss';

const cn = classNames.bind(styles);

const SectionGoal = (): ReactElement => {
  return (
    <section className={cn('goal')}>
      <div className={cn('container')}>

        <div className={cn('goal__image-container')}>
          <picture>
            <source
              srcSet="
                /images/pages/Company/VisionAndStrategy/ship.webp 1x,
                /images/pages/Company/VisionAndStrategy/ship@2x.webp 2x
              "
              sizes='100vw'
            />
            <img
              className={cn('goal__image')}
              src='/images/pages/Company/VisionAndStrategy/ship.webp'
              alt='Digitization'
            />
          </picture>
        </div>

        <div className={cn('goal__description')}>
          <p className={cn('goal__paragraph')}>
            DFA has a vision to build greater transaction density between members, 
            and then deliver container provision and ocean freight opportunity in 
            the future as a neutral platform , building opportunity on the back of 
            DP World’s physical asset base and data feed from that base.
          </p>
          <p className={cn('goal__paragraph')}>
            This is the next stage of the journey as we progress through 2022 and 2023. 
            These were also the subject of discussions at the first DFA Global members 
            Meeting held in Dubai during March 2022.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionGoal;